const PLACEMENT_IDS = process?.env?.CONNATIX_PLACEMENT_ID?.split(",") ?? [];

const getNextPlacementId = (currentIndex) => {
  if (currentIndex >= PLACEMENT_IDS.length) {
    return { placementId: null, nextIndex: currentIndex };
  }

  const placementId = PLACEMENT_IDS[currentIndex];
  currentIndex++;

  return { placementId, nextIndex: currentIndex };
};

const hasEnabledVideosOpenLoop = (content) => {
  return (
    content?.boxes?.some((box) =>
      box.innerBoxes?.[0]?.subItems?.some((subItem) =>
        subItem.params?.content?.some(
          (contentItem) =>
            contentItem.videosOpenLoop?.enabled === true ||
            contentItem.relatedContent?.some(
              (relatedItem) => relatedItem.type === "videos2"
            )
        )
      )
    ) ?? false
  );
};

export const hasVideoConnatix = (content = {}, template = "") => {

  let checkJWPlayer = content?.mainSectionTree?.find((section) => {
      const value = section?.metadata?.checkJWPlayer;
      return value != null && value !== "";
  })?.metadata?.checkJWPlayer || "false";
  checkJWPlayer = content?.sections?.find((section) => {
      const value = section?.metadata?.checkJWPlayer;
      return value != null && value !== "";
  })?.metadata?.checkJWPlayer || checkJWPlayer;

  if (checkJWPlayer === true) {
    return false;
  }

  let connatixMonetizationPlaylistId = content?.mainSectionTree?.find((section) => {
      const value = section?.metadata?.connatixMonetizationPlaylistId;
      return value != null && value !== "";
  })?.metadata?.connatixMonetizationPlaylistId || false;
  connatixMonetizationPlaylistId = content?.sections?.find((section) => {
      const value = section?.metadata?.connatixMonetizationPlaylistId;
      return value != null && value !== "";
  })?.metadata?.connatixMonetizationPlaylistId || connatixMonetizationPlaylistId;

  const templateWithMonetization = ["normal", "mega", "small"];
  if (templateWithMonetization.includes(content?.metadata?.typeWeb) && connatixMonetizationPlaylistId) {
    return true;
  }

  const enabledTemplates = ["Video", "VideoAMP", "Videos"];
  if (enabledTemplates.includes(template)) {
    return true;
  }
  
  if (content?.related?.videos?.length > 0) {
    return true;
  }

  if (
    content?.body?.length > 0 &&
    content?.body?.some((item) => (item.type === "video" || item.value?.body?.some((liveBlogItem) => liveBlogItem.type === "video")))
  ) {
    return true;
  }
  /* if (template === "TemplateBuilder" || template === "SectionBuilder") {
    return hasEnabledVideosOpenLoop(content);
  } */
  return false;
};

export const addPlacementIdToContent = (content = null, template = "") => {
  if (!content) {
    return content;
  }
  let currentIndex = 0;
  let contentWithPlacementId;
  // isArray
  if (Array.isArray(content)) {
    contentWithPlacementId = [...content];
  } else {
    contentWithPlacementId = { ...content };
  }
  if (template === "TemplateBuilder" || template === "SectionBuilder") {
    contentWithPlacementId.boxes = content?.boxes?.map((box) => {
      box.innerBoxes?.[0]?.subItems?.forEach((subItem) => {
        subItem.params?.content?.forEach((contentItem) => {
          if (contentItem.videosOpenLoop?.enabled === true) {
            const { placementId, nextIndex } = getNextPlacementId(currentIndex);
            currentIndex = nextIndex;
            contentItem.videosOpenLoop.placementId = placementId;
          }
          
          if (contentItem.type === "videos2") {
            const { placementId, nextIndex } =
              getNextPlacementId(currentIndex);
            currentIndex = nextIndex;
            contentItem.placementId = placementId;
          }
        });
      });
      return box;
    });
  } else if (template === "Videos" && contentWithPlacementId?.[0]) {
    const { placementId } = getNextPlacementId(currentIndex);
    contentWithPlacementId[0].placementId = placementId;
  } else if (template === "Video") {
    const { placementId } = getNextPlacementId(currentIndex);
    contentWithPlacementId.placementId = placementId;
  } else {
    if (content?.related?.videos?.length > 0) {
      const { placementId, nextIndex } = getNextPlacementId(currentIndex);
      currentIndex = nextIndex;
      contentWithPlacementId.related.videos[0].placementId = placementId;
    }
    if (content?.body?.length > 0) {
      contentWithPlacementId.body = content?.body?.map((item) => {
        if (item.type === "video") {
          const { placementId, nextIndex } = getNextPlacementId(currentIndex);
          currentIndex = nextIndex;
          item.placementId = placementId;
        } else if (item.type === "liveblog") {
          item.value?.body?.forEach((liveBlogItem) => {
            if (liveBlogItem.type === "video") {
              const { placementId, nextIndex } =
                getNextPlacementId(currentIndex);
              currentIndex = nextIndex;
              liveBlogItem.placementId = placementId;
            }
            return liveBlogItem;
          });
        }
        return item;
      });
    }
  }
  return contentWithPlacementId;
};
